import { Outlet } from '@tanstack/react-router';
import { Bounce, ToastContainer } from 'react-toastify';
import { MobileNavigationHeader } from '@Components/happyFlowTemplate/MobileNavigationHeader.tsx';
import { DesktopSideBar } from '@Components/happyFlowTemplate/desktopSideBar/DesktopSideBar.tsx';
import { PasswordlessDesktopSideBar } from '@Components/happyFlowTemplate/passwordlessDesktopSideBar/passwordlessDesktopSideBar';
import { FormStateProvider } from '@Providers/formStateProvider/FormStateProvider.tsx';
import { useBoundStore } from '@Store/index';

export const HappyFlowTemplate = () => {
  const isEmbedded = useBoundStore((state) => state.onboardingSlice.getIsEmbedded());
  return (
    <div className='h-full flex flex-col sm:flex-row items-center fade-in '>
      <MobileNavigationHeader />
      {isEmbedded ? <PasswordlessDesktopSideBar /> : <DesktopSideBar />}
      <FormStateProvider>
        <div className='flex flex-col overflow-hidden h-full  gap-[32px] relative w-full'>
          <div className='w-full h-full flex justify-center no-scrollbar'>
            <Outlet />
            <ToastContainer aria-label='Notifications' transition={Bounce} />
          </div>
        </div>
      </FormStateProvider>
    </div>
  );
};
